import React, { Component } from 'react';
import { Stage, Layer, Circle } from 'react-konva';
import { colors } from '../../../constants';
import _ from 'lodash';
import { Transformer } from 'react-konva';
import './CanvasContent.css';

class CanvasContent extends Component {

    state = {
        circleX: null,
        circleY: null,
        rectangles: [],
        selectedShapeName: '',
        getConvasDataArr: [],
        stepFourComplited: false,
        color: colors
    };

    render() {
        let count = 0 ;
        let colorCount = 0
        let parentSegmentY;
        let rounds = _.map(this.props.circleData, (rect, i) => {
            if (this.props.groupId === rect.groupId) {
                let color = !rect.competitorId
                if(color){
                    count += 1
                    colorCount = 0
                }else{
                    colorCount+=1
                }
                let fill = this.state.color[count].color[colorCount]

                let attractivnessY = this.props.segmentAttractiveness.attractivnessData.Items[0].segmentTotal.find(r => r.segmentId === rect.segmentId);

                if (!attractivnessY && !rect.competitorId){
                    attractivnessY = parentSegmentY = this.props.segmentAttractiveness.attractivnessData.Items[0].segmentTotal.find(r => r.segmentName === rect.name);
                }

                // console.log('data', this.props.segmentAttractiveness.attractivnessData.Items[0].segmentTotal);
                // console.log('rect.segmentId', rect.segmentId)

                let x = (100 * (+rect.value - 100)) / 900;
                let posX = x * 332 / 100
                let y;

                if (rect.competitorId && rect.totalScore) {
                    y = 100 - ((100 * (((+rect.totalScore) - 100))) / 900);
                } else if (rect.competitorId && parentSegmentY) { 
                    y = 100 - ((100 * ((+parentSegmentY.value - 100))) / 900);
                } else {
                    y = attractivnessY ? 100 - ((100 * ((+attractivnessY.value - 100))) / 900) : 1;
                }

                let posY = y * 332 / 100

                return (
                    <Circle
                        key={i}
                        // ref={rect.subName ? ref=>this[`${rect.name}`]=ref : ref=>this[`${rect.name}`]=ref}
                        x={posX}
                        y={posY}
                        scaleX='1'
                        scaleY='1'
                        width={'20'}
                        height={'20'}
                        stroke="black"
                        strokeWidth='2'
                        fill={'#' + fill}
                        type='circle'
                        context='text'
                    />
                )
            }
        });

        return (
            <div className="canvas-content">
                <div className='text-part'>
                    <p className='title'>Segment Attractiveness</p>
                    <div className='label-val'>
                        <p className='high'>High - 1000</p>
                        <p className='medium'>Medium - 550</p>
                        <p className='low'>Low - 100</p>
                    </div>
                </div>
                <div className='stage-box'>
                    <Stage
                        width={332}
                        height={332}
                        ref={ref => this.stage = ref}
                    >
                        <Layer
                            ref={ref => this.layer = ref}
                            fillPatternImage={this.state.fillPatternImage}
                        >
                            {rounds}
                            <Transformer
                                ref={node => {
                                    this.transformer = node;
                                }}
                            />
                        </Layer>
                    </Stage>
                </div>
                <div className='bottom-text-part'>
                    <div className='label-val'>
                        <p className='low'>Low - 100</p>
                        <p className='medium'>Medium - 550</p>
                        <p className='high'>High - 1000</p>
                    </div>
                    <p className='title'>Ability to Compete</p>
                </div>
                <table className="bg-table">
                    <tbody>
                        <tr>
                            <td className='topLeft colorBox'></td>
                            <td className='topMiddle'></td>
                            <td className='topRight colorBox'></td>
                        </tr>
                        <tr>
                            <td className='middleLeft'></td>
                            <td className='middleMiddle colorBox'></td>
                            <td className='middleRight'></td>
                        </tr>
                        <tr>
                            <td className='btmLeft colorBox'></td>
                            <td className='btmMiddle'></td>
                            <td className='btmRight colorBox'></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        );
    }
}

//export default (<Test />, document.getElementById('root'));
export default (CanvasContent);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/SegmentPriority/TabContent/CanvasContent/CanvasContent.jsx